export const ProductsOrder = {
  agent: 1,
  customer: 2,
  bi: 3,
} as const;

export type ProductKey = 'agent' | 'bi' | 'customer';

export const ProductsType = {
  agent: 'agent',
  bi: 'bi',
  customer: 'customer',
} as const;

export const ProductsTypeBack = {
  agent: 'coagent',
  bi: 'cobi',
  customer: 'cocustomer',
} as const;

export type ProductTypeBack = (typeof ProductsTypeBack)[keyof typeof ProductsTypeBack];

// Project types from the URL or the store are plain strings.
export const isProductKey = (value: unknown): value is ProductKey =>
  typeof value === 'string' && Object.hasOwn(ProductsType, value);

// The backend's name for a project type, or undefined for an unknown one.
export const toProductTypeBack = (value: unknown): ProductTypeBack | undefined =>
  isProductKey(value) ? ProductsTypeBack[value] : undefined;

export const ProductsTypeBackPretty = {
  agent: 'CoAgent',
  bi: 'CoBI',
  customer: 'CoCustomer',
} as const;

export const ProductsTypeColor = {
  agent: 'blue',
  bi: 'yellow',
  customer: 'purple',
} as const;
